// EnvRibbon — a small fixed badge that marks non-production environments (#76).
// In prod it renders nothing. In dev/qa it shows the environment name so a
// tester can never mistake a demo/staging build for the live product.
import React from 'react';
import CONFIG from '@/lib/config';

const EnvRibbon: React.FC = () => {
    if (CONFIG.APP_ENV === 'prod') return null;

    const isDev = CONFIG.APP_ENV === 'dev';
    return (
        <div
            aria-hidden
            className={[
                'fixed bottom-1 left-1 z-[9999] pointer-events-none select-none',
                'px-2 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wider',
                'shadow-sm border',
                isDev
                    ? 'bg-amber-100 text-amber-800 border-amber-300'
                    : 'bg-sky-100 text-sky-800 border-sky-300',
            ].join(' ')}
            title={`Environment: ${CONFIG.APP_ENV} (not production)`}
        >
            {CONFIG.APP_ENV}
        </div>
    );
};

export default EnvRibbon;
